"use client"
import type { EmblaCarouselType as CarouselApi } from "embla-carousel"
import type useEmblaCarousel from "embla-carousel-react"
import { createContext } from "use-context-selector"
import type { CarouselProps } from "./types"

type CarouselContextProps = {
  carouselRef: ReturnType<typeof useEmblaCarousel>[0]
  api: ReturnType<typeof useEmblaCarousel>[1]
  scrollPrev: () => void
  scrollNext: () => void
  canScrollPrev: boolean
  canScrollNext: boolean
  scrollTo: (...options: Parameters<CarouselApi["scrollTo"]>) => void
  navigationApi?: ReturnType<typeof useEmblaCarousel>[1]
  setNavigationApi?: (api: ReturnType<typeof useEmblaCarousel>[1]) => void
  selectedIndex: number
} & CarouselProps

export const CarouselContext = createContext<CarouselContextProps | null>(null)
